export function initHome(){



		var Homepage = Barba.BaseView.extend({
		namespace: 'home',
		onEnter: function() {
				// The new Container is ready and attached to the DOM.

			//Video intro home
			(function () {
				var bv = new Bideo();
				bv.init({
					// Video element
					videoEl: document.querySelector('#background_video'),

					// Container element
					container: document.querySelector('#video_container'),

					// Resize
					resize: true,
					autoplay: true,

					// Array of objects containing the src and type
					// of different video formats to add
					src: [
						{
							//src: './videos/intro-supratec-syneo.mp4',
							//type: 'video/mp4'
						}
					],

					// What to do once video loads (initial frame)
					onLoad: function () {
					document.querySelector('#video_cover').style.display = 'none';
					}
				});
			}());

		},
		onEnterCompleted: function() {
				// The Transition has just finished.

				
		}
	});

	// Don't forget to init the view!
	Homepage.init();


	
}
